import { Box, CircularProgress, Grid, Skeleton } from '@mui/material';
import React from 'react';
import ExperienceCardLoadingSkeleton from '../../../feature/components/Experiences/ExperienceCardLoadingSkeleton';

export default function ExperienceListLoadingComponent({
    isSmallChat,
    mapOpen,
}: {
    isSmallChat?: boolean;
    mapOpen?: boolean;
}) {
    return (
        <>
            {' '}
            {Array.from(new Array(10)).map((item, index) => (
                <Grid
                    key={index}
                    item
                    xs={isSmallChat ? 30 : mapOpen ? 30 : 60}
                    sm={isSmallChat ? 30 : mapOpen ? 30 : 30}
                    md={isSmallChat ? 30 : mapOpen ? 30 : 20}
                    lg={isSmallChat ? 30 : mapOpen ? 30 : 15}
                    xl={isSmallChat ? 30 : mapOpen ? 30 : 12}
                >
                    <ExperienceCardLoadingSkeleton />
                </Grid>
            ))}
        </>
    );
}
